import * as React from 'react'

import Localization from '~/client/src/shared/localization/LocalizationManager'

interface IProps {
  message?: string
}

const OptionsEmpty: React.FC<IProps> = ({ message }) => {
  return (
    <div
      data-slot="options-empty"
      className="tw:flex tw:items-center tw:justify-center tw:px-3 tw:py-6 tw:text-body-md tw:text-muted-foreground"
    >
      {message ?? Localization.translator.noResults}
    </div>
  )
}

export default OptionsEmpty
